import React from 'react';

import PropTypes from 'prop-types';
import Switch from 'react-switch';

import { Heading, FormContainer } from './css';
import { useLocalizedStringsContext } from '../../../../../context/LocalizedStringsContext';

const TwoFactorAuthentication = ({ fieldData, setFieldData }) => {
  const { isAuthDisabled } = fieldData;

  const {
    manageAccount: { lavel2fa }
  } = useLocalizedStringsContext();
  return (
    <div>
      <Heading>{lavel2fa}</Heading>
      <FormContainer>
        <Switch
          onColor="#4B286D"
          onChange={() =>
            setFieldData(previousValue => ({
              ...previousValue,
              isAuthDisabled: !isAuthDisabled
            }))
          }
          checked={!isAuthDisabled}
        />
      </FormContainer>
    </div>
  );
};

TwoFactorAuthentication.propTypes = {
  fieldData: PropTypes.shape({
    role: PropTypes.number,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    email: PropTypes.string,
    contactNumber: PropTypes.string,
    provinces: PropTypes.arrayOf(PropTypes.string),
    channels: PropTypes.arrayOf(PropTypes.string),
    outlet: PropTypes.string,
    cpmsId: PropTypes.string,
    xid: PropTypes.string,
    storeCode: PropTypes.string,
    dealership: PropTypes.arrayOf(PropTypes.string),
    channelOrgCode: PropTypes.string,
    salesManager: PropTypes.string,
    salesManagerEmail: PropTypes.string,
    isAuthDisabled: PropTypes.bool
  }).isRequired,
  setFieldData: PropTypes.func.isRequired
};

export default TwoFactorAuthentication;
